export const currencyData = {
  97: {
    tokens: ["tBNB", "BUSD", "USDT", "USDC"],
    poolFee: "0.001 tBNB",
    poolFeeAmount: "0.001",
    multiSenderFee: "0.01",
    airdropFee: "0.001",
  },
  56: {
    tokens: ["BNB", "BUSD", "USDT", "USDC"],
    poolFee: "0.5 BNB",
    poolFeeAmount: "0.5",
    multiSenderFee: "0.01",
    airdropFee: "0.25",
  },
  1: {
    tokens: ["ETH", "USDT", "USDC"],
    poolFee: "0.1 ETH",
    poolFeeAmount: "0.1",
    multiSenderFee: "0.01",
    airdropFee: "0.05",
  },
  137: {
    tokens: ["POL", "USDT", "USDC"],
    poolFee: "50 POL",
    poolFeeAmount: "50",
    multiSenderFee: "0.01",
    airdropFee: "25",
  },
  43114: {
    tokens: ["AVAX", "USDT", "USDC"],
    poolFee: "5 AVAX",
    poolFeeAmount: "5",
    multiSenderFee: "2.5",
    airdropFee: "2.5",
  },
  42161: {
    tokens: ["ETH", "USDT", "USDC"],
    poolFee: "0.1 ETH",
    poolFeeAmount: "0.1",
    multiSenderFee: "0.01",
    airdropFee: "0.1",
  },
  10: {
    tokens: ["ETH", "USDT", "USDC"],
    poolFee: "0.1 ETH",
    poolFeeAmount: "0.1",
    multiSenderFee: "0.01",
    airdropFee: "0.1",
  },
  8453: {
    tokens: ["ETH", "USDT", "USDC"],
    poolFee: "0.1 ETH",
    poolFeeAmount: "0.1",
    multiSenderFee: "0.01",
    airdropFee: "0.1",
  },
  42220: {
    tokens: ["CELO", "CUSD", "USDT", "USDC"],
    poolFee: "300 CELO",
    poolFeeAmount: "300",
    multiSenderFee: "0.01",
    airdropFee: "2.5",
  },
  250: {
    tokens: ["FTM", "USDT", "USDC"],
    poolFee: "300 ftm",
    poolFeeAmount: "300",
    multiSenderFee: "0.01",
    airdropFee: "0.05",
  },
  11155111: {
    tokens: ["ETH", "USDT", "USDC"],
    poolFee: "0.0001 ETH",
    poolFeeAmount: "0.0001",
    multiSenderFee: "0.01",
    airdropFee: "0.000001", // Updated to match deployed contract (10000000000000000 wei)
  },
  80002: {
    tokens: ["MATIC", "USDT", "USDC"],
    poolFee: "0.1 MATIC",
    poolFeeAmount: "0.1",
    multiSenderFee: "0.01",
    airdropFee: "0.01",
  },
};
